export default __webpack_public_path__ + "noofuploaddark-icon.svg";